// SEO Redirect Component
// Handles client-side redirects with proper SEO signals
// Note: For true 301 redirects, server-side configuration is recommended

import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

/**
 * SEORedirect Component
 * Provides client-side redirect with SEO-friendly signals:
 * - Canonical URL pointing to new location
 * - Meta refresh as fallback for bots that don't execute JS
 * - Immediate navigation via React Router
 */
const SEORedirect = ({ to }) => {
  const location = useLocation();
  
  // Get the full URL for the canonical tag
  const baseUrl = window.location.origin;
  const newUrl = `${baseUrl}${to}`;

  useEffect(() => {
    // Log redirect for debugging/analytics
    console.log(`SEO Redirect: ${location.pathname} -> ${to}`);
  }, [location.pathname, to]);

  return (
    <>
      <Helmet>
        {/* Canonical URL - tells search engines the preferred URL */}
        <link rel="canonical" href={newUrl} />
        {/* Meta refresh - fallback for bots that don't execute JavaScript */}
        <meta httpEquiv="refresh" content={`0;url=${to}`} />
        {/* Tell search engines this is a permanent redirect */}
        <meta name="robots" content="noindex, follow" />
        <title>Redirecting...</title>
      </Helmet>
      {/* Immediate client-side redirect using replace (doesn't create history entry) */}
      <Navigate to={to} replace />
    </>
  );
};

export default SEORedirect;
